export default {
	title: 'Elementos desativados',
	empty: 'Nenhum elemento desativado neste cenário',
	no_scenario: 'Selecione um cenário para ver os elementos desativados'
};
